import { types } from 'mobx-state-tree';

export const StatisticTest = types.model({
  id: types.number,
  alert_caption: types.string,
  rule: types.map(types.frozen()),
});
